import { breakpoints } from "./utilities.js";

const leftCol = document.querySelector('.js-left-col')
const rightCol = document.querySelector('.js-right-col')

const init = (leftCol, rightCol) => {
    // Booking widget pos:sticky wont work on the new design due to the bookingwidget being taller than the screenheight (on the average laptop)
    // Since the layout grid in use is *old* and the cols are set to display: inline-block we cant get equal height cols via CSS (easily/no hacks)
    // Lets cheaply get the col height here and set inline, then pos: sticky will work with no other effort
    if (!leftCol || !rightCol) {
        return
    }

    if (window.innerWidth >= breakpoints.desktop) {
        rightCol.style.height = `${leftCol.offsetHeight}px`;

        const leftHeight = leftCol.offsetHeight;
        const rightHeight = rightCol.scrollHeight;

        if (leftHeight < rightHeight) {
            const expectedMinHeight = `${rightHeight}px`;
            setLeftColMinHeight(leftCol, expectedMinHeight)
        }
    } else {
        const expectedMinHeight = '';
        setLeftColMinHeight(leftCol, expectedMinHeight)
        rightCol.style.height = '';
    }
};

const setLeftColMinHeight = (leftCol, expectedMinHeight) => {
    if (leftCol.style.minHeight === expectedMinHeight)
        return;
    
    leftCol.style.minHeight = expectedMinHeight;
}

// ...Since the page can load content in via AJAX the left col height can be 100px by the time this fires, so have added resizeObserver
let resizeTimeout = 0;
const resizeObserver = new ResizeObserver(() => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => init(leftCol, rightCol), 50);
});
resizeObserver.observe(leftCol);

export default init;
